export class Settings {
    public constructor(settings: any) {
        Object.assign(this, settings);
    }
}
export interface Settings {
    base: string;
    url(url: string): string;
    name: string;
    author: string;
    description: string;
    minDate: string;
    mainMenu: Array<{ icon: [string, string]; title: string; to: string; exact: boolean }>;
    errorPages: {
        default: { icon: [string, string]; title: string; message: string; statusCode: number };
        [code: string]: { icon: [string, string]; title: string; message: string; statusCode: number };
    };
    cardTypeQuestionId: string;
    cardTypeAnswerId: string;
    programId: string;
    surveyId: string;
    sourceId: string;
    usResidentQuestionId: string;
    usResidentYesAnswerId: string;
    usResidentNoAnswerId: string;
    commercialInsuranceQuestionId: string;
    commercialInsuranceYesAnswerId: string;
    commercialInsuranceNoAnswerId: string;
    nonCashPayingQuestionId: string;
    nonCashPayingYesAnswerId: string;
    nonCashPayingNoAnswerId: string;
    planPartiallyCoveredQuestionId: string;
    planPartiallyCoveredYesAnswerId: string;
    planPartiallyCoveredNoAnswerId: string;
    planFullyCoveredQuestionId: string;
    planFullyCoveredYesAnswerId: string;
    planFullyCoveredNoAnswerId: string;
    stateHealthcareProgramsQuestionId: string;
    stateHealthcareProgramsYesAnswerId: string;
    stateHealthcareProgramsNoAnswerId: string;
    applicableTcsQuestionId: string;
    applicableTcsYesAnswerId: string;
    applicableTcsNoAnswerId: string;

    // Keeping these existing for now
    patientConsentQuestion: string;
    patientConsentAnswer: string;
    isUSResidentQuestion: string;
    isUSResidentAnswer: string;
    hasInsuranceQuestion: string;
    hasInsuranceAnswer: string;
    notPayingCashQuestion: string;
    notPayingCashAnswer: string;
    coversCostPartiallyQuestion: string;
    coversCostPartiallyAnswer: string;
    coversCostFullyQuestion: string;
    coversCostFullyAnswer: string;
    notEnrolledQuestion: string;
    notEnrolledAnswer: string;
    hasPrescriptionQuestion: string;
    hasPrescriptionAnswer: string;
    hasDiscussedQuestion: string;
    hasDiscussedAnswer: string;
    indicationQuestion: string;
    indicationEpithelioidSarcoma: string;
    indicationFollicularLymphoma: string;
    isSixteenOrOlderAnswer: string;
    agreeCheckBox: string;
    agreeCheckBoxYes: string;
}
